/* import __COLOCATED_TEMPLATE__ from './info-modal-button.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';

export default class InfoModalButton extends Component {
    tagName = '';

    name = 'default';
    bodyArgs = {};
    useBody = true;
    size = null;
    openHelp = null;

    /**
     * Any overrides to the default behavior will have to be
     * provided to the component
     */
    @action onClick(event) {
        event = event || window.event;
        event.preventDefault();

        this.openHelp(`info_modal.${this.name}.title`, `info_modal.${this.name}.body`, { ...this.bodyArgs });
    }
}
